import { combineReducers } from 'redux'
import { all } from 'redux-saga/effects'
import { loadingReducer as loading } from './loading'
import { farmReducer as farm, farmSaga } from './farm'
import { usersReducer as users, usersSaga } from './users'
import { vaccineReducer as vaccine, vaccineSaga } from './vaccine'
import { lotsReducer as lots, lotsSaga } from './lots'
import { locationsReducer as locations, locationsSaga } from './locations'
import { holeProcessReducer as holeProcess, holeProcessSaga } from './holeProcess'
import { settingsReducer as settings, settingsSaga } from './settings'
import { animalReducer as animal, animalSaga } from './animal'
import { breedReducer as breed, breedSaga } from './breed'
import { pastureReducer as pasture, pastureSaga } from './pasture'
import { geneticEvaluationReducer as geneticEvaluation, geneticEvaluationSaga } from './geneticEvaluation'
import { vaccineHistoryReducer as vaccineHistory, vaccineHistorySaga } from './vacineHistory'
import { animalRecordsReducer as animalRecords, AnimalRecordsSaga } from './animalRecords'
import { coatReducer as coats, CoatSaga } from './coat'
import { pendingRecordsReducer as pendingRecords, PendingRecordsSaga } from './records'
import { bloodGradeReducer as bloodGrade, bloodGradeSaga } from './blodGrau'

export const rootReducer = combineReducers({
  loading,
  farm,
  users,
  vaccine,
  lots,
  locations,
  holeProcess,
  settings,
  animal,
  breed,
  pasture,
  geneticEvaluation,
  vaccineHistory,
  animalRecords,
  coats,
  pendingRecords,
  bloodGrade
})

export type RootState = ReturnType<typeof rootReducer>

// eslint-disable-next-line
export function* rootSaga() {
  yield all([
    farmSaga,
    usersSaga,
    vaccineSaga,
    lotsSaga,
    locationsSaga,
    holeProcessSaga,
    settingsSaga,
    animalSaga,
    breedSaga,
    pastureSaga,
    geneticEvaluationSaga,
    vaccineHistorySaga,
    AnimalRecordsSaga,
    CoatSaga,
    PendingRecordsSaga,
    bloodGradeSaga
  ])
}
